import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from './services/login.service';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { Observable, forkJoin } from 'rxjs';
import { ConfigManagerProperties } from './enums/config-manager-properties.enum';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'xpo-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.scss'],
})
export class LoginComponent {
  userForm: FormGroup;
  errorMessage = null;

  constructor(private loginService: LoginService, private dialogRef: MatDialogRef<LoginComponent>, private fb: FormBuilder, private configManager: ConfigManagerService) {
    this.createForm();
  }

  /** closes the dialog */
  close() {
    this.dialogRef.close('canceled');
  }

  onSubmit() {
    this.errorMessage = null;
    const userName = this.userForm.get('username').value;
    const password = this.userForm.get('password').value;
    this.loginService.loginByApplication(userName, password).subscribe(
      data => {
        this.dialogRef.close(data);
      },
      error => {
        if (error.error.error_description && error.error.error) {
          this.errorMessage = `${error.error.error_description}`;
          this.errorMessage = this.errorMessage.replace('@carbon.super', '');
        } else {
          this.errorMessage = error.error;
        }
        this.loginService.clear();
      }
    );
  }

  private createForm() {
    this.userForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }
}
